import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { FiArrowRight } from "react-icons/fi";
import FlowField from "../components/forms/FlowField";
import "./styles/flow-form.css";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import Loader from "../components/loader/Loader";
import { createCompany } from "../redux/actions/CompanyActions";

// Validation schema
const validationSchema = Yup.object({
  turnover: Yup.string().required("Le montant est requis"),
});

const OHADA_COUNTRIES = [
  "BJ",
  "BF",
  "CM",
  "CF",
  "KM",
  "CG",
  "CD",
  "CI",
  "GQ",
  "GA",
  "GN",
  "GW",
  "ML",
  "NE",
  "SN",
  "TD",
  "TG",
];

function Turnover() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        turnover: values.turnover,
      }),
    );

    await dispatch(
      createCompany(
        user.token,
        {
          businessType: cart.businessType,
          businessName: cart.businessName,
          address: cart.businessAddress,
          activitySector: cart.sectorActivity,
          turnover: values.turnover,
          country: cart.businessCountry,
        },
        handleCreateCompanyCallback,
      ),
    );
  };

  const handleCreateCompanyCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      const countryCode = (
        cart?.businessCountry ||
        cart?.company?.country ||
        ""
      ).toUpperCase();
      if (
        OHADA_COUNTRIES.includes(countryCode) &&
        cart.from === "domiciliation"
      ) {
        navigate("/domiciliation");
      } else if (cart.from === "management") {
        navigate("/platform-gest");
      } else {
        if (cart?.businessCountry === "CM" || cart?.company?.country === "CM") {
          navigate("/platform-admin");
        } else {
          navigate("/platform-juridique");
        }
      }
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="flow-form-page">
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <header className="flow-form-header">
        <h1 className="flow-form-title">
          Quel est le <span>chiffre d'affaires</span> annuel de votre entreprise
          ?
        </h1>
        <p className="flow-form-lead">
          Une estimation suffit. Elle nous permet de vous proposer le bon tarif.
        </p>
      </header>

      <Formik
        initialValues={{ turnover: cart.turnover ?? "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="flow-form" noValidate>
          <FlowField
            name="turnover"
            type="number"
            inputMode="numeric"
            min={0}
            label="Chiffre d'affaires annuel (FCFA)"
            placeholder="Ex. : 25 000 000"
          />

          <div className="flow-actions">
            <button type="submit" className="flow-submit" disabled={submitting}>
              Continuer <FiArrowRight aria-hidden="true" />
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default Turnover;
